import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import GreenMonster from './components/GreenMonster';
import GameHistoryPage from './components/history/GameHistoryPage';
import GameDetailPage from './components/history/GameDetailPage';
import FranchiseHistoryPage from './components/history/FranchiseHistoryPage';
import MlbContentPage from './components/content/MlbContentPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<GreenMonster />} />
        <Route path="/history" element={<GameHistoryPage />} />
        <Route path="/franchise/:yearParam?" element={<FranchiseHistoryPage />} />
        <Route path="/content" element={<MlbContentPage />} />
        <Route path="/game/:slug" element={<GameDetailPage />} />
        <Route path="/game/pk/:gamePk" element={<GameDetailPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;